<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                :pages="[
                    {
                        name: $t('messages.absenteeism'),
                        href: null,
                    },
                ]"
            />
        </template>

        <div>
            <NavLinks :links="meta.navLinks.schoolYears" />
        </div>

        <form :action="meta.links.index" method="GET" @submit.prevent="filter" class="p-4">
            <div class="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 md:grid-cols-12">
                <div class="sm:col-span-3">
                    <div class="mt-1">
                        <FormLabel :value="$tc('messages.groups', 1)" for="group_id" />
                        <FormSelect
                            id="group_id"
                            v-model="form.group_id"
                            :options="options.groups"
                            class="mt-1 w-full"
                        />
                        <FormError :value="form.errors.group_id" class="mt-2" />
                    </div>
                </div>

                <div class="sm:col-span-2">
                    <label class="block text-sm font-medium leading-5 text-gray-700"> &nbsp; </label>
                    <div class="flex justify-end space-x-2">
                        <SubmitFormButton
                            :button-text="$t('messages.filter')"
                            :processing="form.processing"
                            is-filter
                        />
                    </div>
                </div>
            </div>
        </form>

        <div v-if="students.length === 0" class="flex flex-col mt-5">
            <EmptyState picture />
        </div>
        <div v-else>
            <div class="flex flex-col mt-5">
                <div class="-my-2 py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8">
                    <div
                        class="align-middle inline-block min-w-full shadow overflow-hidden sm:rounded-lg border-b border-gray-200"
                    >
                        <table class="min-w-full divide-y divide-gray-200">
                            <thead>
                                <tr>
                                    <th
                                        class="px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                    >
                                        {{ $t('messages.student') }}
                                    </th>
                                    <th
                                        v-if="filters.group_id === null"
                                        class="px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                    >
                                        {{ $t('messages.group') }}
                                    </th>
                                    <th
                                        class="px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                    >
                                        {{ $t('messages.unjustified') }}
                                    </th>
                                    <th
                                        class="px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                    >
                                        {{ $t('messages.justified') }}
                                    </th>
                                    <th
                                        class="px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                    >
                                        {{ $t('messages.present') }}
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                    v-for="(student, index) in students"
                                    :key="student.id"
                                    :class="index % 2 === 0 ? 'bg-white' : 'bg-gray-50'"
                                >
                                    <td class="px-6 py-4 whitespace-nowrap text-sm leading-5 font-medium text-gray-900">
                                        <span v-if="student.is_study_variable">*</span>
                                        <InertiaLink :href="student.links.show" class="text-indigo-500">
                                            {{ student.full_name }}
                                        </InertiaLink>

                                        <BadgePill color="yellow" v-if="student.active === false">
                                            {{ $t('messages.inactive') }}
                                        </BadgePill>
                                    </td>
                                    <td
                                        v-if="filters.group_id === null"
                                        class="px-6 py-4 whitespace-nowrap text-sm leading-5 text-gray-500"
                                    >
                                        {{ student.group_name }}
                                    </td>
                                    <td class="px-6">
                                        {{ student.percentageString }}
                                        <span class="text-gray-400"> {{ student.unjustified_count }}</span>
                                    </td>
                                    <td class="px-6">
                                        {{ student.percentageJustifiedString }}
                                        <span class="text-gray-400"> {{ student.justified_count }}</span>
                                    </td>
                                    <td class="px-6">
                                        {{ student.presentString }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import EmptyState from '@/components/EmptyState.vue';
import BadgePill from '@/components/BadgePill.vue';
import NavLinks from '@/components/NavLinks.vue';
import FormError from '@/components/Forms/FormError.vue';
import FormLabel from '@/components/Forms/FormLabel.vue';
import SubmitFormButton from '@/Pages/Teacher/Activities/Subactivities/SubmitFormButton.vue';
import FormSelect from '@/components/Forms/FormSelect.vue';

export default {
    components: {
        FormSelect,
        SubmitFormButton,
        FormLabel,
        FormError,
        NavLinks,
        BadgePill,
        PanelPage,
        EmptyState,
    },
    layout: Layout,
    name: 'Show',
    props: ['meta', 'students', 'filters', 'options'],
    data() {
        return {
            form: this.$inertia.form({
                group_id: this.filters.group_id,
                school_year_id: this.filters.school_year_id,
            }),
        };
    },
    methods: {
        filter() {
            this.form.get(this.meta.links.index);
        },
    },
};
</script>
